import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import HSCodeCreateForm from '~/containers/hsCodeCreate/hsCodeCreate';

export class HSCodeCreatePage extends Component {
  render() {
    const cancelButton = (
      <Link to={`/ingredients`}>
        <Button color="secondary">Cancel</Button>
      </Link>
    );

    return (
      <Page>
        <TitleBar back="/settings/hscodes" backText="HS Codes" title="Add HS Code" button={cancelButton} />
        <HSCodeCreateForm />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(HSCodeCreatePage));



// WEBPACK FOOTER //
// ./src/pages/hsCodeCreate/hsCodeCreate.jsx